import { PaletteMode } from '@mui/material';
import { deepPurple, grey, orange } from '@mui/material/colors';

export const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
      mode,
      primary: {
        ...deepPurple,
        ...(mode === 'dark' && {
          main: deepPurple[300],
        }),
      },
      secondary: {
        ...orange,
        ...(mode === 'dark' && {
          main: orange[400],
        }),
      },
      ...(mode === 'dark' && {
        background: {
          default: grey[900],
          paper: grey[900],
        },
      }),
      text: {
        ...(mode === 'light'
          ? {
              primary: grey[900],
              secondary: grey[800],
            }
          : {
              primary: '#fff',
              secondary: grey[500],
            }),
      },
    },
  });
  
